var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8PlusOuGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13.398438 4.9902344 A 1.50015 1.50015 0 0 0 12.740234 7.7929688 L 33.613281 20.044922 L 12.699219 33.230469 A 1.5009861 1.5009861 0 1 0 14.300781 35.769531 L 37.300781 21.269531 A 1.50015 1.50015 0 0 0 37.259766 18.707031 L 14.259766 5.2070312 A 1.50015 1.50015 0 0 0 13.548828 4.9902344 A 1.50015 1.50015 0 0 0 13.398438 4.9902344 z M 13.5 40 A 1.50015 1.50015 0 1 0 13.5 43 L 36.5 43 A 1.50015 1.50015 0 1 0 36.5 40 L 13.5 40 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PlusOuGal);
export default __webpack_public_path__ + "static/media/icons8-plus-ou-égal.3b7dd150371a523321f161be14715740.svg";
export { ForwardRef as ReactComponent };